
const initialState = { 
  "userId": "",
  "username": "",
  "tabList": null,
  "language": "ENGLISH"
};

const currentUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_CURRENT_USER':
      return action.currentUser;
    case 'LOGOUT_USER':
          return { 
            "userId": "",
            "username": "",
            "tabList": null,
            "language": "ENGLISH"
          };
    default:
      break;
  }
  return state;
}

export default currentUserReducer;